import { render } from "./BookingSuccessView.vue?vue&type=template&id=175a6f1c&scoped=true&ts=true"
import script from "./BookingSuccessView.vue?vue&type=script&lang=ts"
export * from "./BookingSuccessView.vue?vue&type=script&lang=ts"

import "./BookingSuccessView.vue?vue&type=style&index=0&id=175a6f1c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-175a6f1c"]])

export default __exports__